import React from 'react';
import { Navbar, Nav, NavbarBrand, NavItem, Container, Row, Col } from 'reactstrap';
import { Link, browserHistory } from 'react-router';
import auth from './auth';
import querystring from 'query-string';

import 'bootstrap/dist/css/bootstrap.min.css';

class Base extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        let a = document.createElement('a');
        a.href = document.referrer;

        let parentQuery = querystring.parse(a.search.substring(1));
        if (parentQuery && typeof parentQuery === 'object' && parentQuery._at === 'providers') {
            browserHistory.push(`/providers${window.location.search}${window.location.hash}`);
        }
    }

    _onSessionChange() {
        // Change detected; wipe session
        window.sessionStorage.removeItem('session_state');
        window.sessionStorage.removeItem('access_token');
        window.location.reload();
    }

    _hasAccessToken() {
        return auth.getAccessToken() !== null;
    }

    render() {
        return (
            <div>
                <Navbar color="light" light expand>
                    <NavbarBrand>
                        DDX SmartBrush
                    </NavbarBrand>
                    <Nav navbar>
                        <NavItem>
                            <Link className="navbar-link" to="/providers">
                                Brush Providers
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link className="navbar-link" to="/patients">
                                Patient Management
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link className="navbar-link" to="/analytics">
                                Analytical Configuration
                            </Link>
                        </NavItem>
                        {/*<NavItem>
                            <Link className="navbar-link" to="/settings">
                                Scorecard Settings
                            </Link>
                        </NavItem>*/}
                    </Nav>
                </Navbar>
                <Container>
                    <Row>
                        <Col>
                            {this.props.children}
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Base;